<template>
	<div class="search-country">
		<label class="search-country__label">
			<input
				class="search-country__input"
				:placeholder="placeholder"
				@input="searchCountry"
				@focus="showSearchList"
				@blur="hideSearchList"
				ref="input"
				@keyup.down.prevent="selectByArrow(0, true)"
				@keypress.enter.prevent="$emit('enter')"
			/>
		</label>
		<ul class="search-country__country-selector" v-if="showSearchCountry">
			<li
				v-for="(country, idx) in countryList"
				:key="idx"
				ref="selectorList"
			>
				<button
					type="button"
					class="search-country__country-selector__btn"
					@keydown.up.prevent="
						selectByArrow(idx === 0 ? 'input' : idx - 1)
					"
					@keydown.down.prevent="
						selectByArrow(
							idx + 1 === countryList.length ? idx : idx + 1
						)
					"
					@click="setCountry(country)"
					@blur="hideSearchList"
				>
					{{ country }}
				</button>
			</li>
		</ul>
	</div>
</template>
<script>
	import debounce from 'lodash/debounce';

	export default {
		name: 'SearchBrandCountry',
		props: {
			castSearchType: {
				type: String,
				default: 'castId',
			},
			placeholder: {
				type: String,
				default: '국가를 검색해 주세요',
			},
		},
		data() {
			return {
				showSearchCountry: false,
				countryList: [],
				allCountryList: [],
			};
		},
		methods: {
			selectByArrow(idx, fromInput) {
				const selectorList = this.$refs.selectorList;
				if (fromInput) {
					this.$refs.input.focus();
					setTimeout(() => {
						selectorList[idx]
							.querySelector(
								'.search-country__country-selector__btn'
							)
							.focus();
					});
					return;
				}
				if (!selectorList || idx === 'input') {
					this.$refs.input.focus();
					return;
				}
				selectorList[idx]
					.querySelector('.search-country__country-selector__btn')
					.focus();
			},
			searchCountry: debounce(async function (event) {
				const word = event.target.value;
				if (word.length) {
					try {
						const res = await this.$axiosAdmin2.get(
							`/api/brands/country/kr?search=${word}`
						);
						this.countryList = [...res.data];
					} catch (error) {
						console.error(error);
					}
				} else {
					this.countryList = [...this.allCountryList];
				}
			}, 500),
			setCountry(country) {
				this.$emit('change', country);
				this.$refs.input.value = country;
				this.showSearchCountry = false;
				this.searchWord = country;
				this.searchCountry({ target: { value: country } });
			},
			showSearchList() {
				this.showSearchCountry = true;
			},
			async loadInitialCountries() {
				try {
					const res = await this.$axiosAdmin2.get(
						`/api/brands/country/kr`
					);
					this.allCountryList = [...res.data];
					this.countryList = [...res.data];
				} catch (error) {
					console.error(error);
				}
			},
			hideSearchList(event) {
				if (
					!Array.from(this.$refs.selectorList).some(el =>
						el.contains(event.relatedTarget)
					)
				) {
					this.showSearchCountry = false;
				}
			},
			init() {
				this.$refs.input.value = '';
				this.countryList = [...this.allCountryList];
			},
		},
		mounted() {
			this.loadInitialCountries();
		},
	};
</script>

<style lang="scss" scoped>
	.search-country {
		margin: 10px 0;
		&__input {
			width: 300px;
			height: 35px;
			border-radius: 4px;
			border: 1px solid #dfe6ee;
			padding: 10px;
		}

		&__country-selector {
			position: absolute;
			overflow: scroll;
			z-index: 999;
			width: 300px;
			min-height: 100px;
			max-height: 300px;
			background-color: #fff;
			border: solid 1px #dfe6ee;
			border-radius: 5px;
			padding: 1em 0;
			font-size: 0.875rem;
		}

		&__country-selector__btn {
			width: 100%;
			padding: 0.5em 1em;
			cursor: pointer;
			text-align: left;
			&:focus,
			&:hover {
				background: #f4f7fa;
			}
		}
	}
</style>
